import UserNote from 'owa-mail-store/lib/store/schema/UserNote';
import { USER_NOTE_EXTENDED_PROPERTY_URI } from 'owa-user-highlighting/lib/utils/constants';
import createSetItemExtendedPropertyField from 'owa-mail-store/lib/services/utils/createSetItemExtendedPropertyField';
import UpdateItemResponse from 'owa-service/lib/contract/UpdateItemResponse';
import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(itemIdToUpdate: string, itemUserNotes: UserNote[]) {
    const userNoteExtendedPropertyType = extendedPropertyType({
        ExtendedFieldURI: USER_NOTE_EXTENDED_PROPERTY_URI,
        Value: JSON.stringify(itemUserNotes),
    });
    const update = createSetItemExtendedPropertyField(userNoteExtendedPropertyType);
    const singleItemChange = itemChange({
        Updates: [update],
        ItemId: itemId({ Id: itemIdToUpdate }),
    });

    return updateItemRequest({
        ItemChanges: [singleItemChange],
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

export default function saveUserNoteService(
    itemId: string,
    itemUserNotes: UserNote[]
): Promise<UpdateItemResponse> {
    const requestBody = createRequestBody(itemId, itemUserNotes);

    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
